import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { IUserProfileInfo } from '@shared/interfaces/user-profile-info.interface';
import { Observable } from 'rxjs';
import { IUsersService } from '@shared/interfaces/users-service.interface';

@Injectable()
export class UserProfileResolverService {
  private usersService: IUsersService = inject(IUsersService);

  /* eslint-disable @typescript-eslint/no-unused-vars */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IUserProfileInfo> {
    return this.usersService.getProfile();
  }
}
